<div class="flex flex-column">
     
  <section class="hero">
    <div class="hero-overlay"></div>
      <div class="hero-content">
        <div class="hero-title-box">
          <div class="hero-brand" aria-hidden="true">
            <img src="/static/images/logo/qa4sm_logo_long.webp" 
                alt="QA4SM logo" class="hero-logo" />
          </div>
          <h1 class="hero-title">
            <span class="line">Quality Assurance Service</span>
            <span class="line highlight">for Satellite Soil Moisture Data</span>
          </h1>

          <div class="hero-actions">
            @if (userLoggedIn$ | async) {
              <a pButton label="See Results" routerLink="/published-validations" class="btn-action-home" role="button"></a>
              <a pButton label="Try It"      routerLink="/validate"              class="btn-action-home" role="button"></a>
            } @else {
              <a pButton label="See Results" routerLink="/published-validations" class="btn-action-home" role="button"></a>
              <a pButton label="Sign Up"     routerLink="/signup"                class="btn-action-home" role="button"></a>
            }
          </div>
        </div>

        <div class="scroll-down">
          <button
          pButton
          id="scroll-down-btn"
          title="Scroll Down"
          class="btn-scroll-down p-button-rounded p-button-text"
          icon="pi pi-chevron-down"
          (click)="goToNews()">
        </button>
      </div>
    </div>
  </section>

  <!-- News Section -->
  <section class="containerDark">
    <div class="container-text">
    
      @if (settings$ | async; as settings) {
        <div class="container-text"
          id="qa4smNews"
          [ngClass]="qa4smNewsClass.main">
          <h1 class="text-center">What's new</h1>
          <div [innerHTML]="settings[0].news"></div>
        </div>
      }
    </div>
  </section>

  <!-- about-->
  <section class="containerLight" aria-labelledby="about-title">
    <div class="container-text">
    <!-- Intro -->
        <h1 class="text-center">Soil moisture validation service</h1>
        <h3>Validate satellite soil moisture data against in-situ observations and model references.</h3>
        <p>
          A unified platform that <span class="text-highlighted">brings together methodologies and protocols</span> for
          the validation and quality control of soil moisture data products, delivering
          <span class="text-highlighted">traceable validation results</span> you can explore, share, and publish.
        </p>
        <div class="about__actions mb-2">
          <a
          pButton
          label="How it works"
          routerLink="/help"
          class="p-button-rounded p-button-outlined"
          role="button">
          </a>
          <a
          pButton
          label="Run a validation"
          routerLink="/validate"
          class="p-button-rounded p-button-outlined"
          role="button">
          </a>
        </div>
      <!-- Feature Grid -->
      <div class="about__grid" role="list">
        <!-- Simple -->
        <article class="feature-card fadeInLeft" role="listitem"> 
          <div class="feature-card__icon" aria-hidden="true">
            <i class="pi pi-compass"></i>
          </div>
          <h3 class="feature-card__title">Simple</h3>
          <p class="feature-card__body">
            An easy interface for comparing satellite soil moisture data against land surface models and the
            <a href="https://ismn.earth/" target="_blank" rel="noreferrer noopener">International Soil Moisture Network</a>.
          </p>
        </article>

        <!-- Traceable -->
        <article class="feature-card fadeInLeft" role="listitem">
          <div class="feature-card__icon" aria-hidden="true">
            <i class="pi pi-link"></i>
          </div>
          <h3 class="feature-card__title">Traceable</h3>
          <p class="feature-card__body">
            Download results in netCDF and as visualisations, share them, or publish via
            <a href="https://zenodo.org/" target="_blank" rel="noreferrer noopener">Zenodo</a>.
          </p>
        </article>

        <!-- Free -->
        <article class="feature-card fadeInRight" role="listitem">
          <div class="feature-card__icon" aria-hidden="true">
            <i class="pi pi-unlock"></i>
          </div>
          <h3 class="feature-card__title">Free</h3>
          <p class="feature-card__body">
            Just set up an account to have full access to all functionalities.
          </p>
        </article>

        <!-- Customizable -->
        <article class="feature-card fadeInRight" role="listitem">
          <div class="feature-card__icon" aria-hidden="true">
            <i class="pi pi-sliders-h"></i>
          </div>
          <h3 class="feature-card__title">Customizable</h3>
          <p class="feature-card__body">
            Upload your own data and apply filtering and scaling options to assess their impact on validation results.
          </p>
        </article>
      </div>
    </div>
  </section>

  <section class="containerDark">
    <div class="container-text">
      <!-- Application videos -->
      <h1 class="text-center"> Step-by-step video tutorials</h1>
      <p class="about__lead">
        Explore a series of short <span class="text-highlighted">hands-on tutorials</span> that guide you through every part of the QA4SM platform — 
        from setting up your first validation to interpreting results and publishing them.  
        Learn how to <span class="text-highlighted">upload custom data, compare satellite data,</span> and make the most of QA4SM’s validation tools.
      </p>
    </div>
    <div class="application-videos">
      <p-carousel
          [value]="videos"
          [circular]="true"
          [numVisible]="1"
          [numScroll]="1"
          [showIndicators]="false"
          [showNavigators]="true"
          [responsiveOptions]="responsiveOptions"
          styleClass="videos-carousel">

        <ng-template let-video pTemplate="item">
          <div class="video-slide">
            <h3 class="video-title">{{ video.title }}</h3>
            <!-- IMPORTANT: the container has the aspect ratio, the iframe fills it -->
            <div class="iframe-container">
              <iframe
                [src]="video.video"
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen>
              </iframe>
            </div>
          </div>
        </ng-template>
      </p-carousel>
    </div>
  </section>

  <!-- Team -->
  <section class="containerLight">
    <div class="container-text">
      
      <h1 class="text-center"> Project Team and Partners</h1>
      <div class="flex flex-column flex-wrap">
        
        <!--        FFG -->
        <div [ngClass]="applicationTeamClass.partner">
          <div [ngClass]="applicationTeamClass.partnerDesc">
            The <b>QA4SM</b> project provides an operational online validation service for soil moisture products. It
            started
            in May 2018 and was supported by the <a href="https://www.ffg.at/en" target="_blank">Austrian Research
            Promotion Agency</a> (Österreichische Forschungsförderungsgesellschaft, FFG) in the
            <a href="https://www.ffg.at/en/program/austrian-space-applications-programme-0" target="_blank">Austrian
              Space
              Application
              Programme</a>.
          </div>

          <div [ngClass]="applicationTeamClass.partnerLogo">
            <a href="https://www.ffg.at/en" rel="noreferrer" target="_blank" class="text-center">
              <p-image width="190" height="66.5" alt="FFG logo" [src]="logoFiles[3].plot" class=""></p-image></a>
          </div>
        </div>

        <!--        ESA -->
        <div [ngClass]="applicationTeamClass.partner">
          <div [ngClass]="applicationTeamClass.partnerDesc">
            From 2021 on, <b>QA4SM</b> is further evolved within the <a href="https://project-frm4sm.geo.tuwien.ac.at/"
                                                                        target="_blank">FRM4SM</a> project, supported by
            the <a
            href="https://www.esa.int/" target="_blank">European Space Agency</a>.
          </div>
          <div [ngClass]="applicationTeamClass.partnerLogo">
            <a href="https://www.esa.int/" target="_blank" class="text-center">
              <p-image width="190" height="70" alt="ESA logo" [src]="logoFiles[2].plot"></p-image>
            </a>
          </div>
        </div>
        <div class="horizontal-line my-1"></div>
        <!--        TU -->
        <div [ngClass]="applicationTeamClass.team">
          <div [ngClass]="applicationTeamClass.teamLogo">
            <a href="https://www.tuwien.at/en/mg/geo/climers" target="_blank">
              <p-image width="165" height="79" alt="TU logo" [src]="logoFiles[1].plot"></p-image>
            </a>
          </div>
          <div [ngClass]="applicationTeamClass.teamDesc">
            <b>TU Wien (Vienna University of Technology)</b><br>
            Department of Geodesy and Geoinformation<br>
            Research Group Climate and Environmental Remote Sensing (CLIMERS)<br>
            <b>Website: </b> <a href="https://www.tuwien.at/en/mg/geo/climers" target="_blank">
            CLIMERS</a><br>
            <b>Contact:</b> Alexander Gruber (alexander.gruber (at) geo.tuwien.ac.at)<br>
            <b>Tasks:</b> Scientific lead and research, dataset support
          </div>
        </div>

        <!--      AWST-->
        <div [ngClass]="applicationTeamClass.team">
          <div [ngClass]="applicationTeamClass.teamLogo">
            <a href="https://www.awst.at/" target="_blank">
              <p-image width="165" height="100" alt="AWST logo" [src]="logoFiles[0].plot"></p-image>
            </a>
          </div>
          <div [ngClass]="applicationTeamClass.teamDesc">
            <b>AWST (Applied Science, Software and Technology)</b><br>
            <b>Website:</b> <a href="https://www.awst.at" target="_blank"> AWST</a><br>
            <b>Contact: </b> Alexander Boresch (boresch (at) awst.at)<br>
            <b>Tasks: </b> Project management, technical lead, webservice development and operations
          </div>
        </div>

        <!--        CESBIO -->
        <div [ngClass]="applicationTeamClass.team">
          <div [ngClass]="applicationTeamClass.teamLogo">
            <a href="https://www.cesbio.cnrs.fr/homepage/" target="_blank">
              <p-image width="165" height="90" alt="CESBIO logo" [src]="logoFiles[4].plot"></p-image>
            </a>
          </div>
          <div [ngClass]="applicationTeamClass.teamDesc">
            Within the <b>FRM4SM</b> project, <b>QA4SM</b> has been scientifically developed in cooperation with
            <a href="https://www.cesbio.cnrs.fr/homepage/" target="_blank">CESBIO</a>
          </div>
        </div>
      </div>

    </div>
  </section>

  <!-- Feedback -->
  <section class="containerLight">
    <div class="container-text">
      @if (settings$ | async; as settings) {
        <div id="qa4sm-opinion">
          <h1 class="text-center">Share with us your opinion</h1>
          <p class="text-center">
            If you think we could improve something or you see a missing functionality, please let us know using
            this <a target="_blank" [href]="settings[0].feed_link">feedback form</a>.
          </p>
        </div>
      }  
    </div>
  </section>

  <p-scrollTop styleClass="scroll-button"></p-scrollTop>

</div>

